const prefix = 'USER_ACTIONS_';
export const SET_USER_INFO = `${prefix}SET_USER_INFO`;

// Sagas
export const GET_USER_INFO = `${prefix}GET_USER_INFO`;
